var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixMediaSiteMediaV1StorageInfo from '@wix/ambassador-media-site-media-v1-storage-info/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var MediaType;
(function (MediaType) {
    MediaType["UNKNOWN"] = "UNKNOWN";
    MediaType["IMAGE"] = "IMAGE";
    MediaType["VIDEO"] = "VIDEO";
    MediaType["AUDIO"] = "AUDIO";
    MediaType["DOCUMENT"] = "DOCUMENT";
    MediaType["VECTOR"] = "VECTOR";
    MediaType["ARCHIVE"] = "ARCHIVE";
    MediaType["MODEL3D"] = "MODEL3D";
    MediaType["OTHER"] = "OTHER";
})(MediaType || (MediaType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["WIX_USER"] = "WIX_USER";
    IdentityType["APP"] = "APP";
})(IdentityType || (IdentityType = {}));
export var RootFolder;
(function (RootFolder) {
    /** Root of all site media */
    RootFolder["MEDIA_ROOT"] = "MEDIA_ROOT";
    /** Root of the trash system folder */
    RootFolder["TRASH_ROOT"] = "TRASH_ROOT";
    /** Root of all visitor uploads */
    RootFolder["VISITOR_UPLOADS_ROOT"] = "VISITOR_UPLOADS_ROOT";
})(RootFolder || (RootFolder = {}));
export var Namespace;
(function (Namespace) {
    Namespace["NO_NAMESPACE"] = "NO_NAMESPACE";
    Namespace["OTHERS"] = "OTHERS";
    /** ANY = 2; */
    Namespace["WIX_VIDEO"] = "WIX_VIDEO";
    /** _nsWixMusic */
    Namespace["WIX_MUSIC"] = "WIX_MUSIC";
    /** _nsArtStore */
    Namespace["ALBUMS_AND_ART_STORE"] = "ALBUMS_AND_ART_STORE";
    /** _nsDigitalProduct */
    Namespace["WIX_ECOM"] = "WIX_ECOM";
    /** _nsPhotoShareApp */
    Namespace["PHOTO_SHARE_APP"] = "PHOTO_SHARE_APP";
    /** _nsSharingApp, */
    Namespace["SHARING_APP"] = "SHARING_APP";
    /** engage */
    Namespace["CHAT"] = "CHAT";
    /** logobuilder */
    Namespace["LOGO_BUILDER"] = "LOGO_BUILDER";
    /** WixExposure */
    Namespace["ALBUMS_OLD"] = "ALBUMS_OLD";
    /** chat-mobile-uploads */
    Namespace["CHAT_MOBILE"] = "CHAT_MOBILE";
    /** _nsWixForms */
    Namespace["WIX_FORMS"] = "WIX_FORMS";
})(Namespace || (Namespace = {}));
export var OperationStatus;
(function (OperationStatus) {
    /** File upload or processing failed */
    OperationStatus["FAILED"] = "FAILED";
    /** File is ready for consumption */
    OperationStatus["READY"] = "READY";
    /** File is waiting for processing or currently being processed */
    OperationStatus["PENDING"] = "PENDING";
})(OperationStatus || (OperationStatus = {}));
export var State;
(function (State) {
    /** File is ready for consumption */
    State["OK"] = "OK";
    /** Deleted file */
    State["DELETED"] = "DELETED";
})(State || (State = {}));
const _audioV2 = { assets: 'wix.common.Audio' };
const _fileDescriptor = { media: '_fileMedia' };
const _fileMedia = {
    video: 'wix.common.VideoV2',
    document: 'wix.common.Document',
    image: '_imageMedia',
    audio: '_audioV2',
    vector: '_imageMedia',
    model3d: '_model3D',
};
const _getSiteStorageRequest = {};
const _getSiteStorageResponse = {};
const _imageMedia = {
    image: 'wix.common.Image',
    previewImage: 'wix.common.Image',
};
const _listStorageFilesRequest = {};
const _listStorageFilesResponse = { files: '_fileDescriptor' };
const _model3D = { thumbnail: 'wix.common.Image' };
/**
 * Retrieves a list of files in the Media Manager.
 *
 * To retrieve a list of files from all the folders in the Media Manager
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function listStorageFiles(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            mediaTypes: '$[0].mediaTypes',
            sort: '$[0].sort',
            paging: '$[0].paging',
            fromUpdatedDate: '$[0].fromUpdatedDate',
            toUpdatedDate: '$[0].toUpdatedDate',
            fromSizeInBytes: '$[0].fromSizeInBytes',
            toSizeInBytes: '$[0].toSizeInBytes',
            search: '$[0].search',
            addedBy: '$[0].addedBy',
            rootFolders: '$[0].rootFolders',
            namespaces: '$[0].namespaces',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listStorageFilesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listStorageFilesResponse,
            depSchemas: {
                _audioV2,
                _fileDescriptor,
                _fileMedia,
                _imageMedia,
                _model3D,
            },
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixMediaSiteMediaV1StorageInfo.listStorageFiles(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Get information about the site storage
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function getSiteStorage() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getSiteStorageRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getSiteStorageResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixMediaSiteMediaV1StorageInfo.getSiteStorage(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=media-site-media-v1-storage-info.universal.js.map